import IconDropdownMenu from "../../../../ui/dropdownmenu/icondropdownmenu/icondropdownmenu";
import StatusCard from "../../../../ui/statuscard/statuscard";
import FlagIcon from "../../../../modules/icons/flag";
import FallingChart from "../../../../modules/icons/fallingchart";
import UserContentHeader from "../../header/usercontentheader/usercontentheader";
import RisingChartIcon from "../../../../modules/icons/risingchart";
import DollarIcon from "../../../../modules/icons/dollar";
import CategoryIcon from "../../../../modules/icons/category";
import MonitorIcon from "../../../../modules/icons/monitor";
import {GuideIcon} from "../../../../modules/icons/guide";
import MouseIcon from "../../../../modules/icons/mouse";
import ColumnChart from "../../../../ui/chart/column/columnchart";
import Table from "../../../../ui/table/table";
import {SimpleTable} from "../../../../modals/types/table";

const Dashboard = () => {
    const contentHeaderBox: JSX.Element = (
        <IconDropdownMenu icon={<CategoryIcon/>} title={'همه کمپین ها'} menuItems={
            [
                {
                    title: 'آیتم تست دراپ دون 1', action: () => {
                    }
                },
                {
                    title: 'آیتم تست دراپ دون 2', action: () => {
                    }
                },
            ]
        }/>
    )
    const tableData: SimpleTable = {
        headers: ["عنوان", "هزینه", "کلیک ها", "نمایش ها", "CTR", "سشن ها", "STC", "PPS", "رخداد تگ", "درصد تبدیل", "CPA"],
        bodies: [
            ["همه کمپین ها", "1,148,892", "2 هزار", "3 میلیون", "0.065%", "2 هزار", "87.5%", "1.88", "3.433", "164.73%", "335"],
            ["همه کمپین های همسان", "991,351", "2 هزار", "2 میلیون", "0.071%", "2 هزار", "108.4%", "1.92", "3.299", "207.88%", "301"],
            ["همه کمپین های بنری", "991,351", "2 هزار", "2 میلیون", "0.071%", "2 هزار", "108.4%", "1.92", "3.299", "207.88%", "301"],
            ["همه کمپین های محصول", "991,351", "2 هزار", "2 میلیون", "0.071%", "2 هزار", "108.4%", "1.92", "3.299", "207.88%", "301"],
            ["همه کمپین های تیزر استانی", "991,351", "2 هزار", "2 میلیون", "0.071%", "2 هزار", "108.4%", "1.92", "3.299", "207.88%", "301"],
            ["همه کمپین های شبکه اجتماعی", "991,351", "2 هزار", "2 میلیون", "0.071%", "2 هزار", "108.4%", "1.92", "3.299", "207.88%", "301"],
        ]
    }

    return (
        <div className="User-Dashboard">
            {/*<DataNotFound image={require("../../../assets/images/icons/DataNotFound.svg").default}*/}
            {/*              title={"داده ای برای نمایش وجود ندارد"}*/}
            {/*              body={"اگر داده ای برای گزارش وجود داشته باشد ، نمایش داده خواهد شد."}*/}
            {/*              makeBTN={true}*/}
            {/*              makeBTNText={"ایجاد کمپین جدید"}*/}
            {/*              makeBTNAction={() => {*/}
            {/*              }}*/}
            {/*/>*/}
            <>
                <UserContentHeader title={'داشبورد مدیریت'} icon={<GuideIcon/>} iconColor={"#EF233C"}
                                   box={contentHeaderBox}/>
                <div className="row mt-4">
                    <div className="col-xl-3 col-lg-4 col-md-6 col-12 mb-3">
                        <StatusCard icon={<FlagIcon/>} type={"info"} status={"3"} suffix={"کمپین فعال"}
                                    title={"کمپین های فعال"}
                                    subTitle={"10% افزایش نسبت به هفته گذشته"} chart={<RisingChartIcon/>}/>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-12 mb-3">
                        <StatusCard icon={<MonitorIcon/>} type={"success"} status={"124,622,456"} suffix={"ریال"}
                                    title={"کل نمایش ها"}
                                    subTitle={"10% کاهش نسبت به هفته گذشته"} chart={<FallingChart/>}/>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-12 mb-3">
                        <StatusCard icon={<MouseIcon/>} type={"warning"} status={"124,622,456"} suffix={"ریال"}
                                    title={"متوسط نرخ کلیک"}
                                    subTitle={"10% افزایش نسبت به هفته گذشته"} chart={<RisingChartIcon/>}/>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-12 mb-3">
                        <StatusCard icon={<DollarIcon/>} type={"danger"} status={"124,622,456"} suffix={"ریال"}
                                    title={"تومان هزینه"}
                                    subTitle={"10% افزایش نسبت به هفته گذشته"} chart={<RisingChartIcon/>}/>
                    </div>
                </div>
                <ColumnChart/>
                <Table headers={tableData.headers} bodies={tableData.bodies} rowEachPage={6}/>
            </>
        </div>
    );
}

export default Dashboard;